<template>
    <div data-test-view="reviews-templates-edit-questions-preview">
        <div id="modal-body" class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <p align="justify">
                        <l-text
                            :text="
                                $t(`reviews.admin.labelPreviewQuestionnaireHelp`, {
                                    previewUser: preview.user.fullname,
                                    previewRole: roleTitle,
                                })
                            "
                        />
                    </p>

                    <br />

                    <div
                        v-for="(question, index) in preview.questions"
                        v-show="question.applicableToRole"
                        :key="question._id"
                        style="position:relative;"
                    >
                        <div
                            v-show="question.type == 'reviewSection'"
                            style="padding-bottom: 16px;"
                        >
                            <hr />
                            <h4 class="color-dark">
                                <strong>{{ question.name }}</strong>
                            </h4>
                            <l-text :text="question.description" />
                            <hr />
                        </div>

                        <div
                            v-show="question.type != 'reviewSection'"
                            class="card mouseover-parent"
                        >
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-12">
                                        <strong>{{ question.label }}{{ question.name }}</strong>
                                        <span
                                            v-show="question.private"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpPrivateQuestion`)
                                            "
                                        >
                                            <i class="fa fa-lock l-default-margin-s"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="card-block">
                                <p
                                    v-show="
                                        question.description &&
                                            question.description != '' &&
                                            question.type != 'goalUser'
                                    "
                                    style="margin-bottom: 15px"
                                >
                                    <span>
                                        <l-text :text="question.description" />
                                    </span>
                                </p>

                                <!-- end general info -->

                                <div
                                    v-show="
                                        question.ratingRequirement != 'hidden' &&
                                            question.scale.type != '100'
                                    "
                                    style="display:flex; margin-top: 0px; margin-bottom: -5px"
                                >
                                    <button
                                        v-b-popover.hover.top="question.scale.r1.label"
                                        style="flex: 1 1 0px"
                                        class="btn btn-primary ellipse-text"
                                    >
                                        <span v-show="!question.scale.hideNumbers">1 / </span>
                                        {{ question.scale.r1.label }}
                                    </button>
                                    <button
                                        v-b-popover.hover.top="question.scale.r2.label"
                                        style="flex: 1 1 0px"
                                        class="btn btn-primary l-default-margin ellipse-text"
                                    >
                                        <span v-show="!question.scale.hideNumbers">2 / </span>
                                        {{ question.scale.r2.label }}
                                    </button>
                                    <button
                                        v-if="question.scale.type > 2 && question.scale.r3"
                                        v-b-popover.hover.top="question.scale.r3.label"
                                        style="flex: 1 1 0px"
                                        class="btn btn-primary l-default-margin ellipse-text"
                                    >
                                        <span v-show="!question.scale.hideNumbers">3 / </span>
                                        {{ question.scale.r3.label }}
                                    </button>
                                    <button
                                        v-if="question.scale.type > 3 && question.scale.r4"
                                        v-b-popover.hover.top="question.scale.r4.label"
                                        style="flex: 1 1 0px"
                                        class="btn btn-primary l-default-margin ellipse-text"
                                    >
                                        <span v-show="!question.scale.hideNumbers">4 / </span>
                                        {{ question.scale.r4.label }}
                                    </button>
                                    <button
                                        v-if="question.scale.type > 4 && question.scale.r5"
                                        v-b-popover.hover.top="question.scale.r5.label"
                                        style="flex: 1 1 0px"
                                        class="btn btn-primary l-default-margin ellipse-text"
                                    >
                                        <span v-show="!question.scale.hideNumbers">5 / </span>
                                        {{ question.scale.r5.label }}
                                    </button>
                                    <button
                                        v-if="question.scale.type > 5 && question.scale.r6"
                                        v-b-popover.hover.top="question.scale.r6.label"
                                        style="flex: 1 1 0px"
                                        class="btn btn-primary l-default-margin ellipse-text"
                                    >
                                        <span v-show="!question.scale.hideNumbers">6 / </span>
                                        {{ question.scale.r6.label }}
                                    </button>
                                    <button
                                        v-if="question.scale.type > 6 && question.scale.r7"
                                        v-b-popover.hover.top="question.scale.r7.label"
                                        style="flex: 1 1 0px"
                                        class="btn btn-primary l-default-margin ellipse-text"
                                    >
                                        <span v-show="!question.scale.hideNumbers">7 / </span>
                                        {{ question.scale.r7.label }}
                                    </button>
                                    <button
                                        v-if="question.ratingRequirement == 'optional'"
                                        v-b-popover.hover.top="$t(`reviews.update.helpOptional`)"
                                        class="btn btn-primary"
                                        style="flex: 1 1 0px"
                                    >
                                        N/A
                                    </button>
                                </div>

                                <!-- start on card question form -->

                                <div
                                    v-show="question.commentRequirement != 'hidden'"
                                    style="margin-bottom: 10px; margin-top: 10px"
                                >
                                    <l-input-text
                                        type="textarea"
                                        :label="``"
                                        :placeholder="$t(`reviews.update.placeholderType`)"
                                        :rows="2"
                                    />
                                </div>
                                <div
                                    v-show="
                                        question.ratingRequirement != 'hidden' &&
                                            question.scale.type == '100'
                                    "
                                >
                                    <div class="row">
                                        <div class="col-md-7 col-md-offset-3 volumeRow">
                                            <span
                                                v-b-popover.hover.bottum="question.scale.r1.label"
                                            >
                                                <span style="font-size: 21px;">
                                                    <i
                                                        class="fa fa-rocket color-warning btn-light"
                                                    ></i>
                                                </span>
                                                <br />
                                            </span>
                                            <span style="margin-left: 35px">
                                                <span class="volumeBar">
                                                    <span class="volumebkg"></span>
                                                    <span
                                                        class="volume"
                                                        :style="sliderStyle(index)"
                                                    ></span>
                                                </span>
                                            </span>
                                            <span
                                                v-b-popover.hover.bottum="question.scale.r5.label"
                                                style="margin-left: 35px;"
                                            >
                                                <span style="font-size: 21px">
                                                    <i
                                                        class="fa fa-rocket color-dark btn-light"
                                                    ></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-center explanation">
                                        <i class="fal fa-hand-pointer"></i>
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.update.labelPickLevel`)
                                        }}</span>
                                        {{ " " }}
                                        <span
                                            v-show="question.ratingRequirement == 'optional'"
                                            class="color-primary"
                                            translate=""
                                            >{{ $t(`reviews.update.labelMarkAsNA`) }}</span
                                        >
                                    </div>
                                </div>

                                <!-- multiple choice -->

                                <div v-show="question.answerType == 'multipleChoice'">
                                    <div
                                        v-for="(option, mcIndex) in question.multipleChoiceOptions"
                                        :key="option._id"
                                    >
                                        <label class="color-dark">
                                            <input
                                                v-model="option.selected"
                                                type="checkbox"
                                                @click="selectOption(question, option)"
                                            />
                                            <span class="l-default-margin-s">{{
                                                option.title
                                            }}</span>
                                        </label>
                                        <div
                                            v-show="
                                                mcIndex != question.multipleChoiceOptions.length - 1
                                            "
                                            class="hr-small"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" type="button" @click="cancel()">
                {{ $t(`reviews.admin.btnClosePreview`) }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LInputText from "@/components/LInputText";
import LText from "@/components/LText";

export default {
    components: {
        LInputText,
        LText,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            preview: "reviews/templates/preview",
        }),

        roleTitle() {
            switch (this.preview.role) {
                case "reviewee":
                    return this.$t(`reviews.admin.labelRoleReviewee`);
                case "manager":
                    return this.$t(`reviews.admin.labelRoleManager`);
                case "peer":
                    return this.$t(`reviews.admin.labelRolePeer`);
                case "directReport":
                    return this.$t(`reviews.admin.labelRoleDirectReport`);
                default:
                    return "";
            }
        },
    },
    methods: {
        sliderStyle(index) {
            const percentage = this.preview.questions[index]?.amount ?? 0;

            const borderColor = "transparent transparent #92929D transparent";

            return {
                clip: "rect(0px, " + percentage * 2.2 + "px, 30px, 0px)",
                "border-color": borderColor,
            };
        },
        selectOption(question, option) {
            // Signal allows for multiple answer, simply follow checkboxes native implementation
            //
            if (question.allowMultipleAnswers) {
                return;
            }

            // Signal only allows up to one answer
            //

            // If option is selected, nothing to do here, simply follow checkboxes native implementation
            if (option.selected) {
                return;
            }

            // Unselect all the options and select the current option
            question.multipleChoiceOptions.forEach(function(o) {
                o.selected = false;
            });
            option.selected = true;
        },
        cancel() {
            if (this.$route.path.startsWith(`/reviews/templates/edit/${this.id}/questions`)) {
                this.$router.push(`/reviews/templates/edit/${this.id}/questions`);
            } else if (this.$route.path.startsWith(`/reviews/cycles/edit/${this.id}/questions`)) {
                this.$router.push(`/reviews/cycles/edit/${this.id}/questions`);
            } else if (this.$route.path.startsWith(`/reviews/cycles/edit/${this.id}/confirm`)) {
                this.$emit("close");
                return;
            } else {
                this.$router.go(-1);
            }
        },
    },
};
</script>
